class WuTable {
    constructor(elem) {
        this.SHOW_MORE_PAGE_COUNTER = 10
        this.tabTitle = document.getElementsByClassName('wu-tab wu-tab_big-width');
        this.tabItems = elem.getElementsByClassName('wu-tabs__content--pane active');
        this.activeListItems = this.tabItems[0].getElementsByClassName('list-item-dimension');
        this.latestCounter = this.SHOW_MORE_PAGE_COUNTER;
        this.showMore = elem.querySelector('.showMore');
        this.init();
        this.listeners();
        this.onDisplayShowMore(); 
    }
    init() {
        const iconSort = document.querySelectorAll(".table--icon__sort");

        for (let j = 0; j < (iconSort.length); j++) {
            iconSort[j].addEventListener('click', function (e) {
                toggleClass(iconSort[j], 'asc', 'desc');
                let table, rows, switching, i, x, y, shouldSwitch;
                table = document.querySelectorAll(".table");
                for (let t = 0; t < (table.length); t++) {
                    switching = true;
                    while (switching) {
                        switching = false;
                        rows = table[t].querySelectorAll(".li-item");
                        for (i = 0; i < (rows.length - 1); i++) {
                            shouldSwitch = false;
                            x = rows[i].querySelector(".table-country-item");
                            y = rows[i + 1].querySelector(".table-country-item");
                            if ((iconSort[j].className.indexOf('asc') !== -1 && (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase())) ||
                                iconSort[j].className.indexOf('desc') !== -1 && (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase())) {
                                shouldSwitch = true;
                                break;
                            }
                        }
                        if (shouldSwitch) {
                            rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
                            switching = true;
                        }
                    }
                }
            });
        }

        const searchInput = document.getElementsByClassName("table--search__input");
        const tableMobileView = document.querySelectorAll(".table--mobileview");
        const countryListTotal = document.querySelectorAll(".table--mobileview .li-item")
        for (let i = 0; i <= countryListTotal.length - 1; i++) {
            countryListTotal[i].style.display = "table";
        }

        for (let j = 0; j <= searchInput.length - 1; j++) {
            const countryList = tableMobileView[j].querySelectorAll(".li-item");
            searchInput[j].addEventListener('keyup', function (e) {
                for (let i = 0; i <= countryList.length - 1; i++) {
                    const title = countryList[i].querySelector(".table-country-item").innerText
                    if (title.toUpperCase().indexOf(searchInput[j].value.toUpperCase()) > -1)
                        countryList[i].style.display = "table";
                    else
                        countryList[i].style.display = "none";
                }
            });
        }
    }
    listeners() {
        for(let i=0; i<this.tabTitle.length; i++){
            if (this.tabTitle[i] == undefined){
                continue
            }
            this.tabTitle[i].addEventListener('click', e => {
                const myArr = this.tabTitle[i].getAttribute('id').split("-", -1);
                this.tabItems = document.getElementsByClassName('wu-tabs__content--pane active');
                this.activeListItems = this.tabItems[1].getElementsByClassName('list-item-dimension');
                this.latestCounter = this.SHOW_MORE_PAGE_COUNTER;
                this.showMore = document.getElementsByClassName('showMore')[myArr[2]-1];
                this.showMore.style.display = 'block';
                this.assignShowmore();
                this.onDisplayShowMore();
            })    
        }
        this.assignShowmore();
    }

    assignShowmore(){
        if (document.addEventListener) {
            this.showMore && this.showMore.addEventListener('click', e => {
                this.onshowMore();
            })
        }
    }

    onDisplayShowMore() {
        for (let i = 0; i < this.activeListItems.length; i++) {
            const listCounter = this.activeListItems[i].getAttribute('data-counter');
            if (listCounter >= this.latestCounter) {
                this.activeListItems[i].style.display = 'none';
            }
            else {
                this.activeListItems[i].style.display = 'table';
                this.showMore.style.display = 'block';
            }
            if((listCounter == (this.activeListItems.length-1))&&(this.activeListItems[i].style.display === 'table')){
                this.showMore.style.display = 'none';
            }
            if((listCounter < this.SHOW_MORE_PAGE_COUNTER)){
                this.showMore.style.display = 'block';
            }
        }
    }
    
    onshowMore() {
        this.latestCounter += this.SHOW_MORE_PAGE_COUNTER;
        this.onDisplayShowMore();
    }
}

function intializeTable() {
    const ibanTable = document.querySelectorAll('.wu-table__iban');

    if (ibanTable.length > 0) {
        for (
            let i=0; 
            i<ibanTable.length; 
            i++
        ) {
            new WuTable(ibanTable[i])
        }
    }
}